import { Component, input } from '@angular/core'

import { Mdr } from '../../core/models'

export interface PromoStoneRepricingFees {
    debit: number
    credit: number
    psj1: number
    psj2: number
    rav: number
}

@Component({
    selector: 'app-proposal-mdr-table',
    templateUrl: './proposal-mdr-table.component.html',
    styleUrl: './proposal-mdr-table.component.scss',
})
export class ProposalMdrTableComponent {
    mdr = input.required<Mdr>()
    isPromoStoneConditions = input(false)
    promoStoneFees = input<{
        hitGoal: PromoStoneRepricingFees
        didntReachGoal: PromoStoneRepricingFees
    }>({
        hitGoal: {
            debit: 0,
            credit: 0,
            psj1: 0,
            psj2: 0,
            rav: 0,
        },
        didntReachGoal: {
            debit: 0,
            credit: 0,
            psj1: 0,
            psj2: 0,
            rav: 0,
        },
    })
    isDailyPayment = input(false)
}
